import { postAnalyticsEvent, getParsePointersForSelectedTicket } from './common';

const EVENT_TYPES = {
  CHANGE_SCREEN_VISIBILITY: 'CHANGE_SCREEN_VISIBILITY',
  OPEN_INTERCOM_MESSENGER: 'OPEN_INTERCOM_MESSENGER',
  OPEN_POPUP: 'OPEN_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP',
  CHANGE_MESSAGE_WINDOW_SIZE: 'CHANGE_MESSAGE_WINDOW_SIZE',
  SCROLL_TO_BOTTOM_OF_MESSAGES: 'SCROLL_TO_BOTTOM_OF_MESSAGES',
  SWITCH_OPEN_TICKET: 'SWITCH_OPEN_TICKET',
  NO_SCROLL_BLOCK: 'NO_SCROLL_BLOCK',
  MONITORED_TICKET: 'MONITORED_TICKET',
};

export const trackScreenVisibilityChange = async (hidden) => {
  const parsePointers = getParsePointersForSelectedTicket();
  const params = { hidden };

  return await postAnalyticsEvent(EVENT_TYPES.CHANGE_SCREEN_VISIBILITY, parsePointers, params);
};

export const trackMessageWindowSizeChange = async (large) => {
  const parsePointers = getParsePointersForSelectedTicket();
  const params = { large };

  return await postAnalyticsEvent(EVENT_TYPES.CHANGE_MESSAGE_WINDOW_SIZE, parsePointers, params);
};

export const trackScrollToBottomOfMessagesEvent = async () => {
  const parsePointers = getParsePointersForSelectedTicket();

  return await postAnalyticsEvent(EVENT_TYPES.SCROLL_TO_BOTTOM_OF_MESSAGES, parsePointers);
};

export const trackIntercomOpenEvent = async () => {
  const parsePointers = getParsePointersForSelectedTicket();

  return await postAnalyticsEvent(EVENT_TYPES.OPEN_INTERCOM_MESSENGER, parsePointers);
};

export const trackPopupOpenEvent = async (type) => {
  const params = { type };
  const parsePointers = getParsePointersForSelectedTicket();

  return await postAnalyticsEvent(EVENT_TYPES.OPEN_POPUP, parsePointers, params);
};

export const trackPopupCloseEvent = async (type) => {
  const params = { type };
  const parsePointers = getParsePointersForSelectedTicket();

  return await postAnalyticsEvent(EVENT_TYPES.CLOSE_POPUP, parsePointers, params);
};

export const trackTicketSwitch = async (newConversationId, newTicketSelectionSession) => {
  const params = { newTicketSelectionSession };
  const customParsePointers = [{ name: 'newConversationId', className: 'Conversation', id: newConversationId }];

  return await postAnalyticsEvent(EVENT_TYPES.SWITCH_OPEN_TICKET, {}, params, customParsePointers);
};

export const trackNoScrollBlock = async () => {
  return await postAnalyticsEvent(EVENT_TYPES.NO_SCROLL_BLOCK, {});
};

export const trackTicketIsMonitored = async () => {
  const parsePointers = getParsePointersForSelectedTicket();

  return await postAnalyticsEvent(EVENT_TYPES.MONITORED_TICKET, parsePointers);
};
